import React from 'react'
import ReactDOM from 'react-dom/client'
import './styling/index.css'
import App from './App'
import { BookingsContextProvider } from './context/BookingContext'
import { AuthContextProvider } from './context/AuthContext'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AuthContextProvider>
      <BookingsContextProvider>
        <App />
      </BookingsContextProvider>
    </AuthContextProvider>
)
